import { render, staticRenderFns } from "./NewTask.vue?vue&type=template&id=18964914&scoped=true"
import script from "./NewTask.vue?vue&type=script&lang=js"
export * from "./NewTask.vue?vue&type=script&lang=js"
import style0 from "./NewTask.vue?vue&type=style&index=0&id=18964914&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18964914",
  null
  
)

export default component.exports